module.exports = __webpack_public_path__ + "static/media/12.021.758b96cd.webp";